import { VariantProps } from "@gluestack-ui/utils";
import React from "react";
import { boxStyle } from "./Box.styles";

type IBoxProps = React.ComponentPropsWithoutRef<"div"> & VariantProps<typeof boxStyle> & { className?: string };

const Box = React.forwardRef<HTMLDivElement, IBoxProps>(({ className, ...props }, ref) => {
	return <div ref={ref} className={boxStyle({ class: className })} {...props} />;
});

Box.displayName = "Box";
export { Box };
